import { render, staticRenderFns } from "./BrowseTables.vue?vue&type=template&id=7fa835de&scoped=true&"
import script from "./BrowseTables.vue?vue&type=script&lang=js&"
export * from "./BrowseTables.vue?vue&type=script&lang=js&"
import style0 from "./BrowseTables.vue?vue&type=style&index=0&id=7fa835de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa835de",
  null
  
)

export default component.exports